import { css } from 'styled-components';

import { media } from '../../lib/StyledComponents';

export const RadioInputStyles = css`
  width: 1px;
  height: 1px;
  position: absolute;
  top: 0;
  left: -999px;
  clip: rect(1px, 1px, 1px, 1px);
  overflow: hidden;
  white-space: nowrap;
`;

export const RadioLabelStyles = css`
  width: 100%;
  padding: ${({ theme: { radio } }) => radio.padding};
  transition: all 0.1s ease-out;
  border: ${({ theme: { radio } }) => radio.borderWidth} solid ${({ theme: { radio }}) => radio.colorBorder};
  border-radius: ${({ theme: { input } }) => input.borderRadius};
  box-shadow: ${({ theme: { radio }}) => radio.boxShadow};
  background: ${({ theme: { radioInput } }) => radioInput.colorBackground};
  color: ${({ theme: { radio } }) => radio.colorText};
  text-align: center;
  cursor: pointer;
  display: block;
  white-space: nowrap;
  align-items: center;

  &::before {
    content: '';
    border-radius: 50%;
    box-sizing: content-box;
    width: ${({ theme: { radioInput } }) => radioInput.sizeRadioButton};
    height: ${({ theme: { radioInput } }) => radioInput.sizeRadioButton};
    border: ${({ theme: { radioInput } }) => `${radioInput.borderWidth} solid ${radioInput.colorBorderInactive}`};
    margin-right: ${({ theme: { radioInput } }) => radioInput.labelTextOffset};
    display: inline-block;
    background: ${({ theme: { radioInput } }) => radioInput.colorRadioLabelBackground};
  }

  &::before,
  &::after {
    display: none;
  }

  ${({ theme }) => css`
    ${media.medium`
      transition: none;
      box-shadow: none;
      padding: 0 0.25em 0 0;
      display: flex;
      border: none;
      color: ${theme.text.colorText};
      background-color: transparent;

      &::before,
      &::after {
        display: inline-block;
      }

      ${theme.radioInput.labelColor && css`
        color: ${theme.radioInput.labelColor};
      `}
    `}
  `}
`;

export const MultiRadioLabelStyles = css`
  ${RadioLabelStyles}
  text-align: left;
  align-items: start;
  border: ${({ theme: { radio } }) => radio.borderWidth} solid ${({ theme }) => theme.colorSlate10}};
  color: ${({ theme }) => theme.colorBlack};
`;
